module.exports = "<div class=\"body animated fadeInDown\" id=\"wrapper\">\n  <div id=\"index\">\n    <div class=\"pageTitle\">\n      Platform Admin Console\n    </div>\n    <div class=\"intro-text-container\">\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/service/service.component.html
// module id = ./src/app/service/service.component.html
// module chunks = main